export default __webpack_public_path__ + "static/media/Toilet.681eee69.svg";